import { FEATURE_FLAGS } from '@config/featureFlags'

const featureFlagKeys = Object.keys(FEATURE_FLAGS)

export function getAllowedQueryParametersFromQuery(
    query: Record<string, string | string[] | undefined>
) {
    return Object.keys(query).reduce(
        (all, key) => {
            if (featureFlagKeys.includes(key)) {
                all[key] = query[key]
                return all
            }
            return all
        },
        {} as Record<string, string | string[] | undefined>
    )
}
